import React from 'react';
import './ComingSoon.css';

const Docs = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <span className="coming-soon-icon">📚</span>
        <h1>Documentation</h1>
        <p>Comprehensive guides and documentation coming soon!</p>
      </div>
    </div>
  );
};

export default Docs;
